module.exports = __webpack_public_path__ + "611939a746fa9d514138f30c89776b1c.jpg";